import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _mergeProps({
    class: _ctx.getClasses.wrap
  }, _ctx.$attrs, {
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.listener && _ctx.listener(...args)))
  }), [
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.getClasses.body)
    }, [
      _renderSlot(_ctx.$slots, "before", {}, undefined, true),
      _createElementVNode("span", {
        class: _normalizeClass(_ctx.getClasses.title)
      }, _toDisplayString(_ctx.text), 3),
      _renderSlot(_ctx.$slots, "after", {}, undefined, true)
    ], 2)
  ], 16))
}